import client from "../client/client";

const updateWarehouse = async (data) => {
  try {
    // El backend (UnmarshallWarehouseEvent) espera un array y usa el [0].
    const resp = await client.put("warehouse-api/warehouse/update", [data]);
    return resp;
  } catch (error) {
    console.error("Error al actualizar el depósito:", error);
    throw error;
  }
};

// Crea un depósito nuevo (cuando la empresa aún no tiene ninguno). El backend
// deriva el company_id del user_id vía membership, así que el payload debe
// incluir user_id. Igual que update, espera un array y usa el [0].
const createWarehouse = async (data) => {
  try {
    const resp = await client.post("warehouse-api/warehouse/save", [data]);
    return resp;
  } catch (error) {
    console.error("Error al crear el depósito:", error);
    throw error;
  }
};


// Preferencia de la empresa: preparar pedidos con/sin escáner (toggle del perfil).
const getScanOnPrepare = async (userId) => {
  try {
    const resp = await client.get(`warehouse-api/settings/scan-on-prepare/${userId}`);
    return resp.data?.scan_on_prepare ?? true;
  } catch (error) {
    console.error("Error al obtener preferencia de escáner:", error);
    return true; // fail-soft: por defecto con escáner
  }
};

const setScanOnPrepare = async (userId, value) => {
  const resp = await client.put("warehouse-api/settings/scan-on-prepare", {
    user_id: Number(userId),
    scan_on_prepare: value,
  });
  return resp.data;
};

// Preferencia de la empresa: imprimir etiquetas automáticamente al confirmar el packing.
const getAutoPrintOnConfirm = async (userId) => {
  try {
    const resp = await client.get(`warehouse-api/settings/auto-print-on-confirm/${userId}`);
    return resp.data?.auto_print_on_confirm ?? false;
  } catch (error) {
    console.error("Error al obtener preferencia de auto-impresión:", error);
    return false; // fail-soft: por defecto sin auto-impresión
  }
};

const setAutoPrintOnConfirm = async (userId, value) => {
  const resp = await client.put("warehouse-api/settings/auto-print-on-confirm", {
    user_id: Number(userId),
    auto_print_on_confirm: value,
  });
  return resp.data;
};

let warehouseService = {
  updateWarehouse,
  createWarehouse,
  getScanOnPrepare,
  setScanOnPrepare,
  getAutoPrintOnConfirm,
  setAutoPrintOnConfirm,
};
export default warehouseService;
